import { render, staticRenderFns } from "./CooTranslationDialogue.vue?vue&type=template&id=252d6e13&"
import script from "./CooTranslationDialogue.vue?vue&type=script&lang=ts&"
export * from "./CooTranslationDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports